
/**
 * ページ内でジャンプする際にスムーズスクロールする
 **/
$(function(){
  $(document).on("click", '.toc_list li', function(){
    var adjust = -80;
    var speed = 500;
    var href= $(this).find('a').attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    console.log('done');
    return false;
  });
});